import { React } from "react";

import Button from "@material-ui/core/Button";
import SearchIcon from "@mui/icons-material/Search";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import ConfirmDialog from "../../components/Notification/ConfirmDialog";
import InfoComplaint from "./infoComplaint";
import FiltersComplaints from "./filtersComplaints";
import Pagination from "../../components/Pagination";
import Breadcrumb from "../../components/Breadcrumbs";

import "./styles.css";
import { CircularProgress, Container } from "@mui/material";
import { useSearch } from "../../hooks/seach/useSearch";
import { useSearchFilter } from "../../hooks/seach/useSearchFilter";
import StepStatusList from "./StepStatusList";

const classes = {
    /* Estilização do conteúdo dentro do container */
    paper: {
        padding: 2,
        display: "inline-block",
        overflow: "auto",
        flexDirection: "row",
        minWidth: "100%",
        backgroundColor: "#F5F5F5",
        boxShadow: "none",
        borderRadius: 5,
        marginBottom: 20,
    },

    title: {
        margin: 8,
        color: "#103168",
        fontWeight: 650,
        marginBottom: 30,
        fontFamily: "Rawline",
    },

    textTitle: {
        margin: 1,
        color: "#000",
        fontWeight: 600,
    },

    textDescription: {
        margin: 1,
        color: "rgb(120, 120, 120)",
        marginTop: "20px",
    },

    textDescriptionSecond: {
        margin: 1,
        color: "rgb(120, 120, 120)",
        marginTop: "80px",
        marginBottom: "80px",
    },
    buttonSearch: {
        backgroundColor: "#1351B4",
        border: 0,
        borderRadius: "8px",
        color: "white",
        fontWeight: 700,
        marginTop: 5,
        marginBottom: 5,
        marginLeft: 10,
        display: "inline-block",
        textAlign: "center",
        textDecoration: "none",
        fontSize: "15px",
        lineHeight: "40px",
        transition: "filter 0.2",
    },
    inputs: {
        display: "flex",
        alignItems: "center",
    },
    message: {
        padding: 10,
        backgroundColor: "#FFFBE8",
        color: "rgba(0,0,0,0.8)",
        borderRadius: 7,
        width: "100%",
    },
    containerLoading: {
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
};

export default function Search() {
    const {
        paths,
        complaints,
        limit,
        offset,
        setOffset,
        setSearch,
        isLoading,
        total,
        searchId,
        setSearchId,
        confirmDialog,
        setConfirmDialog,
        allStatuses,
    } = useSearch();

    useSearchFilter();

    return (
        <div style={{ width: "96%", margin: "auto" }}>
            <div style={{ marginTop: 32, marginBottom: 20 }}>
                <Breadcrumb paths={paths} />
            </div>
            <Paper style={classes.paper} elevation={1}>
                <div className="denuncias-container">
                    <div>
                        <div className="search">
                            <Typography variant="h5" align="center" style={classes.title}>
                                Ocorrências Comuns
                            </Typography>

                            <div style={classes.message}>
                                Digite abaixo o código da ocorrência que você gostaria de
                                visualizar o status.
                            </div>

                            <div
                                id="input-text-search"
                                style={classes.inputs}
                                className="search-input"
                            >
                                <input
                                    className="input-text-search"
                                    placeholder="Pesquise uma ocorrência"
                                    type="search"
                                    value={searchId}
                                    onChange={(ev) => setSearchId(ev.target.value)}
                                />

                                <Button
                                    className="button-search"
                                    style={classes.buttonSearch}
                                    variant="outlined"
                                    type="button"
                                    onClick={() => {
                                        setSearch(searchId);
                                        setOffset(0);
                                    }}
                                >
                                    <SearchIcon style={{ color: "#fff" }} />
                                </Button>
                            </div>
                        </div>

                        <FiltersComplaints />

                        <div style={{ marginTop: 30 }}>
                            <Pagination
                                className="pagination"
                                limit={limit}
                                total={total}
                                offset={offset}
                                setOffset={setOffset}
                            />

                        </div>

                        {isLoading ? (
                            <Container style={classes.containerLoading}>
                                <CircularProgress size={80} thickness={5} />
                                <Typography variant="h6" style={{ marginTop: 20 }}>
                                    Carregando...
                                </Typography>
                            </Container>
                        ) : complaints.length > 0 ? (
                            <InfoComplaint complaints={complaints} typeComplaint="normal" />
                        ) : (
                            <div id="allcomplaints">
                                <Typography
                                    variant="h6"
                                    align="center"
                                    style={classes.textDescriptionSecond}
                                >
                                    Não há ocorrências comuns!
                                </Typography>
                            </div>
                        )}

                        <StepStatusList />

                        <Pagination
                            className="pagination"
                            limit={limit}
                            total={total}
                            offset={offset}
                            setOffset={setOffset}
                        />

                        <div
                            style={{
                                width: "100%",
                                textAlign: "center",
                                marginTop: 10,
                                color: "#1351B4",
                                fontWeight: 500,
                            }}
                        >
                            Total de registros encontrados: {total}
                        </div>

                        <ConfirmDialog
                            confirmDialog={confirmDialog}
                            setConfirmDialog={setConfirmDialog}
                        />
                    </div>
                </div>
            </Paper>
        </div>
    );
}
